import ChildRegister from './ChildRegister'
export default ChildRegister


// WEBPACK FOOTER //
// ./src/pages/child/register/index.js